/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import { Input } from 'reactstrap';
import { InputProps } from './InputProps';
import { ColumnInputProps } from './table/InputInterface';

export default function DateInput(props: ColumnInputProps | InputProps) {
  const {
    isDisabled,
    universalTracker,
    valueDataData,
    handleFocus,
    handleValueDataChange,
    placeholder
  } = props;

  const label = ('label' in props) ? props.label : undefined;
  const disabled = isDisabled?.(props);

  const updateValue = (value: string) => {
    if ('updateColumn' in props) {
      props.updateColumn({
        code: props.column.code,
        value: value
      });
      return;
    }

    handleValueDataChange(value);
  }

  const value = 'updateColumn' in props
    ?
    (props.inputColumn.value ?? '')
    :
    (valueDataData ?? '')

  if (value !== null && typeof value === 'object') {
    return <>Unsupported data for date input</>;
  }

  return <div className='input-group mb-3'>
    {label ?? null}
    <Input
      type='date'
      autoComplete='off'
      className='styled-input'
      name={universalTracker.getId()}
      value={value}
      placeholder={placeholder}
      disabled={disabled}
      required={true}
      onFocus={handleFocus}
      onClick={handleFocus}
      onChange={(e) => updateValue(e.target.value)} />
  </div>
}
